import { render, staticRenderFns } from "./Cellphone.vue?vue&type=template&id=54f83fd4&scoped=true&"
import script from "./Cellphone.vue?vue&type=script&lang=js&"
export * from "./Cellphone.vue?vue&type=script&lang=js&"
import style0 from "./Cellphone.vue?vue&type=style&index=0&id=54f83fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f83fd4",
  null
  
)

export default component.exports